import Swal from 'sweetalert2/dist/sweetalert2.js';

// 位置情報を取得するための型定義
interface LocationData {
    latitude: number;
    longitude: number;
    accuracy: number;
    timestamp: number;
}

// 位置情報を取得する関数
const getCurrentLocation = (): Promise<LocationData> => {
    return new Promise((resolve, reject) => {
        // ブラウザが位置情報APIをサポートしているか確認
        if (!navigator.geolocation) {
            reject(new Error('Geolocation is not supported by this browser.'));
            return;
        }

        // 位置情報の取得オプション
        const options: PositionOptions = {
            enableHighAccuracy: true, // 高精度な位置情報を取得
            timeout: 5000, // タイムアウト時間（ミリ秒）
            maximumAge: 0, // キャッシュした位置情報を使用しない
        };

        // 位置情報を取得
        navigator.geolocation.getCurrentPosition(
            (position: GeolocationPosition) => {
                const locationData: LocationData = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    timestamp: position.timestamp,
                };
                resolve(locationData);
            },
            (err: GeolocationPositionError) => {
                switch (err.code) {
                    case err.PERMISSION_DENIED:
                        reject(new Error('User denied the request for Geolocation.'));
                        break;
                    case err.POSITION_UNAVAILABLE:
                        reject(new Error('Location information is unavailable.'));
                        break;
                    case err.TIMEOUT:
                        reject(new Error('The request to get user location timed out.'));
                        break;
                    default:
                        reject(new Error('An unknown error occurred.'));
                        break;
                }
            },
            options
        );
    });
};

const elmList = document.querySelectorAll('button.get-current-location');
elmList.forEach(elmButton => {
    // idを持つ要素を親方向に探す
    var elmParent = elmButton.parentElement;
    var anchor_id = null;
    while (elmParent) {
        if (elmParent.id) {
            anchor_id = elmParent.id;
            break;
        } else if (elmParent.tagName === 'SECTION') {
            // sectionより上は見ない
            break;
        }
        elmParent = elmParent.parentElement;
    }

    elmButton.addEventListener('click', async () => {
        Swal.fire({
            text: '現在位置を取得しています...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();

                getCurrentLocation()
                    .then(location => {
                        // 現在のURLを取得し、idを持つ親タグがあれば#でidを指定してスクロール
                        // 経度、緯度をクエリパラメータとして追加
                        const url = new URL(window.location.href);
                        url.searchParams.set('lat', location.latitude.toString());
                        url.searchParams.set('lng', location.longitude.toString());
                        url.searchParams.set('acc', location.accuracy.toString());

                        // tsはyyyymmddhhmmss形式に変換してtsとして追加
                        // Timezoneはローカルタイムゾーンを使う
                        const date = new Date(location.timestamp);
                        const ts = date.toLocaleString().replace(/[-\/: ]/g, '');
                        url.searchParams.set('ts', ts);

                        // ボタンより上位のidがあればスクロールするように
                        if (anchor_id) {
                            url.hash = `#${anchor_id}`;
                        }

                        // パラメータ付きのURLを表示
                        window.location.href = url.toString();
                    })
                    .catch(err => {
                        Swal.close();

                        Swal.fire({
                            icon: 'error',
                            title: '位置情報の取得に失敗',
                            text: err.message,
                        });
                    });
            },
        });
    });
});
